// frontend/src/components/notes/NoteEditor.js
// GPT5 Specification: TipTap editor with Rich/Markdown/Preview modes

import React, { useState, useCallback, useEffect, useRef, lazy, Suspense } from 'react';
import { useEditor, EditorContent } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import Underline from '@tiptap/extension-underline';
import Link from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyle } from '@tiptap/extension-text-style';
import { Color } from '@tiptap/extension-color';
import Highlight from '@tiptap/extension-highlight';
import TaskList from '@tiptap/extension-task-list';
import TaskItem from '@tiptap/extension-task-item';
import Image from '@tiptap/extension-image';
import {
  Box,
  TextField,
  Button,
  ButtonGroup,
  Paper,
  Typography,
  CircularProgress,
  Alert
} from '@mui/material';
import { Mic, Stop } from '@mui/icons-material';
import { useAuth } from '../../contexts/AuthContext';
import Toolbar from './Toolbar';
import axios from '../../api/axiosConfig';

// Lazy load MinimalNoteEditor for feature flag
const MinimalNoteEditor = lazy(() => import('./MinimalNoteEditor'));

// GPT5 Specification: Limited color palette for consistency
const COLOR_PALETTE = [
  '#374151', // gray
  '#DC2626', // red
  '#EA580C', // orange
  '#EAB308', // yellow
  '#16A34A', // green
  '#2563EB', // blue
  '#9333EA'  // purple
];

const NoteEditor = ({ 
  noteId = null, 
  projectId = null, 
  onSave = () => {}, 
  onCancel = () => {},
  initialTitle = '',
  initialContent = '',
  initialFormat = 'markdown' 
}) => {
  const { currentUser } = useAuth();
  
  // Always use the minimal UI
  return (
    <Suspense fallback={<CircularProgress />}>
      <MinimalNoteEditor
        noteId={noteId}
        projectId={projectId}
        onSave={onSave}
        onCancel={onCancel}
        initialTitle={initialTitle}
        initialContent={initialContent}
        initialFormat={initialFormat}
      />
    </Suspense>
  );
};

export default NoteEditor;